import moment from "moment"
import React from "react"
import { useSelector } from "react-redux"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import "./RenderSummaryHeader.scss"
import { calculateAge } from "core/utils/date"

function RenderSummaryHeader({ patientDetail, smartSummaryData, origin, page }: any) {
  const userRole = useSelector((state: any) => state?.user?.role)

  const getTNM = (row: any) => {
    const keys = Object.keys(row)
    if (keys.length > 0) {
      const stageKey = keys.find((e: any) => e.includes("csStage"))
      const tKey = keys.find((e: any) => e.includes("csPrimaryTumor"))
      const nKey = keys.find((e: any) => e.includes("RegionalLymphNodes"))
      const mKey = keys.find((e: any) => e.includes("csDistantMetastasis"))

      return (
        <>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >Stage: </span>
          <span style={{ marginRight: "20px" }}>
            {row[`${stageKey}`] ? row[`${stageKey}`] : "NA"},
          </span>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >T: </span>
          <span style={{ marginRight: "20px" }}>
            {row[`${tKey}`] ? row[`${tKey}`] : "NA"},
          </span>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >N: </span>{" "}
          <span style={{ marginRight: "20px" }}>
            {row[`${nKey}`] ? row[`${nKey}`] : "NA"},
          </span>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >M: </span>{" "}
          <span style={{ marginRight: "10px" }}>
            {row[`${mKey}`] ? row[`${mKey}`] : "NA"}
          </span>
          <span>&nbsp;&nbsp;{row?.cancerType}</span>
        </>
      )
    }
  }

  const getDrugHistory = (row: any, index: any) => {
    const keys = Object.keys(row)
    let drugHistoryMsg = ""
    if (keys?.length > 0) {
      if (keys?.includes("drugHistory") && row["drugHistory"]) {
        drugHistoryMsg += `Drug History : ${row["drugHistory"]}`
      }
      if (keys?.includes("drugAllergies") && row["drugAllergies"] === "Yes") {
        if (row["drugAllergies"] === "Yes") {
          if (keys?.includes("allergies") && row["allergies"][0]) {
            drugHistoryMsg += `, Allergies : ${row["allergies"][0]}`
          }
        }
      }
      return drugHistoryMsg
    } else {
      return "NA"
    }
  }

  const getIcdValue = (value: any) => {
    if (value) {
      const icdSplitValues: any = value?.split("-")
      if (icdSplitValues?.length > 0) {
        return icdSplitValues[1]
      }
      else {
        return "NA"
      }
    }
  }

  return (
    <div className="summary-header">
      <>
        {
          origin !== "dischargeSummary" && (
            <div className="content first-row">
              <div>{smartSummaryData?.mocId}</div>
              <div>
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientDetail,
                  false,
                  null
                )}
              </div>
              <div>{calculateAge(patientDetail?.dob)}</div>
            </div>
          )
        }
        <div className={`content ${smartSummaryData?.diagnosis?.length <= 0 ? "print-hidden" : ""}`}>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}>Diagnosis: </span>
          <div>
            {smartSummaryData?.diagnosis?.length > 0 ? (
              smartSummaryData?.diagnosis?.map((each: any) => {
                return (
                  <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                    {
                      smartSummaryData?.diagnosis?.length > 1 ?
                        <li>
                          {
                            origin === "dischargeSummary" ?
                              <>
                                <span>{each?.diagnosis}</span>&nbsp;&nbsp;<span className={`${smartSummaryData?.diagnosis?.length === 1 ? "" : ""}`}>{each?.cancerType}</span>
                              </>
                              :
                              <>
                                {each?.diagnosis}&nbsp;&nbsp;{each?.cancerType}
                              </>
                          }
                        </li>
                        :
                        <li>
                          {
                            origin === "dischargeSummary" ?
                              <>
                                <span>{each?.diagnosis}</span>&nbsp;&nbsp;<span className={`${smartSummaryData?.diagnosis?.length === 1 ? "" : ""}`}>{each?.cancerType}</span>
                              </>
                              :
                              <>
                                {each?.diagnosis}&nbsp;&nbsp;{each?.cancerType}
                              </>
                          }
                        </li>
                    }
                  </span>
                )
              })
            ) : (
              <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                <li>NA</li>
              </span>
            )}
          </div>
        </div>

        <div className={`content ${smartSummaryData?.diagnosis?.length <= 0 ? "print-hidden" : ""}`}>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}  >ICD 11 Code: </span>
          <div>
            {smartSummaryData?.diagnosis?.length > 0 ? (
              smartSummaryData?.diagnosis?.map((each: any) => {
                return (
                  <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}  >
                    <li>
                      {
                        origin === "dischargeSummary" ? (
                          <>
                            <span>{each?.icd ? getIcdValue(each?.icd) : "NA"}</span>&nbsp;&nbsp;<span className={`${smartSummaryData?.diagnosis?.length === 1 ? "" : ""}`}>{each?.cancerType}</span>
                          </>
                        ) : (
                          <>
                            {each?.icd ? getIcdValue(each?.icd) : "NA"}&nbsp;&nbsp;{each?.cancerType}
                          </>
                        )
                      }
                    </li>
                  </span>
                )
              })
            ) : (
              <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                <li>NA</li>
              </span>
            )}
          </div>
        </div>

        <div className={`content ${smartSummaryData?.diagnosis?.length <= 0 ? "print-hidden" : ""}`}>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}  >Diagnosed On: </span>
          <div>
            {smartSummaryData?.diagnosis?.length > 0 ? (
              smartSummaryData?.diagnosis?.map((each: any) => {
                return (
                  <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                    <li>
                      {
                        origin === "dischargeSummary" ? (
                          <>
                            <span>{each?.diagnosisDate ? (moment(each?.diagnosisDate).format('DD-MM-YYYY')) : "NA"}</span>&nbsp;&nbsp;<span className={`${smartSummaryData?.diagnosis?.length === 1 ? "" : ""}`}>{each?.cancerType}</span>
                          </>
                        ) : (
                          <>
                            {each?.diagnosisDate ? (moment(each?.diagnosisDate).format('DD-MM-YYYY')) : "NA"}&nbsp;&nbsp;{each?.cancerType}
                          </>
                        )
                      }
                    </li>
                  </span>
                )
              })
            ) : (
              <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                <li>NA</li>
              </span>
            )}
          </div>
        </div>

        <div className={`content ${(!smartSummaryData?.stage || (Array.isArray(smartSummaryData?.stage) && smartSummaryData?.stage?.length <= 0)) ? "print-hidden" : ""}`}>
          <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}>Stage: </span>
          <div>
            {smartSummaryData?.stage?.length > 0 ? (
              smartSummaryData?.stage?.map((each: any, index: number) => {
                return (
                  <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}>
                    <li>{getTNM(each)}</li>
                  </span>
                )
              })
            ) : (
              <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                <li>NA</li>
              </span>
            )}
          </div>
        </div>

        {
          origin !== "dischargeSummary" && (
            <div className="content">
              <span className={`keys ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}  >Allergies: </span>
              <div className="value-wrapper">
                {smartSummaryData?.drugHistoryAndAllergies?.length > 0 ? (
                  smartSummaryData?.drugHistoryAndAllergies?.map(
                    (each: any, index: number) => {
                      return (
                        <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`}  >
                          <li>{getDrugHistory(each, index)}</li>
                        </span>
                      )
                    }
                  )
                ) : (
                  <span className={`value ${origin === "dischargeSummary" ? 'font-weight-light' : ""}`} >
                    <li>NA</li>
                  </span>
                )}
              </div>
            </div>
          )
        }
      </>
    </div>
  )
}

export default RenderSummaryHeader
